import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import axiosInstance from '../axios.config';
import { QuizQuestionsTable } from '../components/QuizQuestions/QuizQuestionsTable';
import { UpdateQuizQuestionModal } from '../components/QuizQuestions/UpdateQuizQuestion';
import { CreateQuizQuestionModal } from '../components/QuizQuestions/CreateQuizQuestionModal';
import { ContentBlock } from '../shared/sharedStyles';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Prev } from 'react-bootstrap/esm/PageItem';

const Questions = () => {
    const { quizid } = useParams();
    const lngsltd = JSON.parse(localStorage.getItem('languageSelected'));
    const [questions, setQuestions] = useState(null);
    const [showAdd, setShowAdd] = useState(false);
    const [newQuestion, setNewQuestion] = useState({
        id: 0,
        quizID: quizid,
        questionText: '',
        questionNo: '',
        imageName: 'No Image',
        questionType: "Single Choice",
        option1: '',
        option2: '',
        option3: '',
        option4: '',
        correctOptions: [],
        imageFile: null,
        languageCode: "en-US"

    });
    const [showEdit, setShowEdit] = useState(false);
    const [editQuestion, setEditQuestion] = useState({
        id: 0,
        quizID: quizid,
        questionText: '',
        questionNo: '',
        imageName: 'No Image',
        questionType: "Single Choice",
        option1: '',
        option2: '',
        option3: '',
        option4: '',
        correctOptions: [],
        imageFile: null,
        languageCode: "en-US"
    });
    const [editQuestionId, setEditQuestionId] = useState(null);

    //Validation Variable
    const [questionTextError, setQuestionTextError] = useState('');
    const [option1Error, setOption1Error] = useState('');
    const [option2Error, setOption2Error] = useState('');
    const [option3Error, setOption3Error] = useState('');
    const [option4Error, setOption4Error] = useState('');
    const [correctOptionError, setCorrectOptionError] = useState('');
    const [editQuestionTextError, setEditQuestionTextError] = useState('');
    const [editOption1Error, setEditOption1Error] = useState('');
    const [editOption2Error, setEditOption2Error] = useState('');
    const [editOption3Error, setEditOption3Error] = useState('');
    const [editOption4Error, setEditOption4Error] = useState('');
    const [editCorrectOptionError, setEditCorrectOptionError] = useState('');

    const [langcodeError, setLangcodeError] = useState('');
    const [questionNumberError, setQuestionNumberError] = useState('');

    useEffect(() => {
        fetchQuestions();
    }, [quizid]);

    const fetchQuestions = async () => {
        try {
            const result = await axiosInstance.get(`/Question/QuizID/${quizid}`);
            const responseData = result.data;
            const sortedData = responseData.slice().sort((a, b) => a.questionNo - b.questionNo);
            setQuestions(sortedData);
        } catch (error) {
            setQuestions([])
            // console.error('Error fetching questions: ', error)
        }
    };

    const handleAdd = () => {
        clearErrors();
        let formIsValid = true;
        if (!newQuestion.questionText) {
            setQuestionTextError(lngsltd['Question Text is required']);
            formIsValid = false;
        } else {
            setQuestionTextError('');
        }
        if (!newQuestion.option1) {
            setOption1Error(lngsltd['Option1 is required']);
            formIsValid = false;
        } else {
            setOption1Error('');
        }
        if (!newQuestion.option2) {
            setOption2Error(lngsltd['Option2 is required']);
            formIsValid = false;
        } else {
            setOption2Error('');
        }
        if (!newQuestion.option3 && newQuestion.questionType !== "True/False") {
            setOption3Error(lngsltd['Option3 is required']);
            formIsValid = false;
        } else {
            setOption3Error('');
        }
        if (!newQuestion.option4 && newQuestion.questionType !== "True/False") {
            setOption4Error(lngsltd['Option4 is required']);
            formIsValid = false;
        } else {
            setOption4Error('');
        }
        // if (!newQuestion.correctOptions && newQuestion.questionType === "") {
        //     setCorrectOptionError(lngsltd['Correct Option is required']);
        //     formIsValid = false;
        // } else {
        //     setCorrectOptionError('');
        // }

        // Check if question number is empty or zero
        if (!newQuestion.questionNo || parseInt(newQuestion.questionNo) === 0) {
            setQuestionNumberError(lngsltd['Question Number is required and cannot be zero']);
            toast.error("Question Number is required and cannot be zero")
            formIsValid = false;
        }
        if (!newQuestion.languageCode) {
            setLangcodeError(lngsltd['Please Select Language']);
            formIsValid = false;
        } else {
            setQuestionNumberError('');
        }

        if (formIsValid) {

            const sortedCorrectOptions = [...newQuestion.correctOptions]
                .sort()
                .join(',');

            const questionData = {
                ...newQuestion,
                correctOptions: sortedCorrectOptions,
            };

            let combinedOptions = '';

            if (newQuestion.questionType !== "True/False") {
                combinedOptions = `${newQuestion.option1},${newQuestion.option2},${newQuestion.option3},${newQuestion.option4}`;
            } else {
                combinedOptions = `${newQuestion.option1},${newQuestion.option2}`;
            }

            const formData = new FormData();

            formData.append('quizID', newQuestion.quizID);
            formData.append('questionText', newQuestion.questionText);
            formData.append('questionType', newQuestion.questionType);
            formData.append('questionNo', newQuestion.questionNo);
            formData.append('options', combinedOptions);


            // ✅ FIX HERE
            if (newQuestion.questionType === "Multiple Choice") {
                formData.append(
                    'correctOption',
                    sortedCorrectOptions
                );
            }
            else {
                formData.append(
                    'correctOption',
                    newQuestion.correctOptions[0] || ""
                );
            }


            if (newQuestion.imageFile) {
                formData.append('imageFile', newQuestion.imageFile);
                formData.append('imageName', "Image");
            } else {
                formData.append('imageName', "No Image");
            }

            formData.append('languageCode', newQuestion.languageCode);


            // Debug before API call
            console.log("Correct Option Sent:",
                newQuestion.questionType === "Multiple Choice"
                    ? sortedCorrectOptions
                    : newQuestion.correctOptions[0]
            );


            axiosInstance.post(`/Question`, formData)
                .then((result) => {
                    setShowAdd(false);
                    fetchQuestions();
                    clear();
                    toast.success(lngsltd['New question has been added']);
                })
                .catch((error) => {
                    toast.error(error);
                });
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewQuestion(prev => {
            if (name === "correctOptions" && prev.questionType !== "Multiple Choice") {
                return {
                    ...prev,
                    correctOptions: [value]
                };
            }

            return {
                ...prev,
                [name]: value
            };
        });
    };

    const handleInputChangeQN = (e) => {
        const { name, value } = e.target;
        const errorMessage = validateQuestionNumber(value);
        setQuestionNumberError(errorMessage);
        setNewQuestion(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleCheckboxChange = (option, checked) => {
        let newCorrectOptions = [...newQuestion.correctOptions];
        if (checked) {
            newCorrectOptions.push(option);
        } else {
            newCorrectOptions = newCorrectOptions.filter(opt => opt !== option);
        }
        newCorrectOptions.sort();

        setNewQuestion({ ...newQuestion, correctOptions: newCorrectOptions });
    };

    const validateQuestionNumber = (value) => {
        if (!/^\d+$/.test(value)) {
            return lngsltd['Please enter only numbers'];
        }

        // else if (parseInt(value) < 1 || parseInt(value) > 1000) {
        //   return "Question Number should be more than 0";          
        // }

        const numValue = parseInt(value);

        // Check if value is less than 1 or greater than 1000
        if (numValue < 1 || numValue > 1000) {
            return "Question Number should be between 1 and 1000";
        }
        return '';
    };


    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "correctOptions" && editQuestion.questionType !== "Multiple Choice") {
            setEditQuestion({ ...editQuestion, correctOptions: [value] });
            if (value.trim()) {
            setCorrectOptionError('');
        }
        } else {
            setEditQuestion({ ...editQuestion, [name]: value });
            if (value.trim()) {

            switch(name) {

                case "questionText":
                    setQuestionTextError('');
                    break;

                case "option1":
                    setOption1Error('');
                    break;

                case "option2":
                    setOption2Error('');
                    break;

                case "option3":
                    setOption3Error('');
                    break;

                case "option4":
                    setOption4Error('');
                    break;

                default:
                    break;
            }
        }
        }
    };


    const handleEditInputChangeQN = (e) => {
        const { name, value } = e.target;
        const errorMessage = validateQuestionNumber(value);
        setQuestionNumberError(errorMessage);
        setEditQuestion(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    const handleEditCheckboxChange = (option, checked) => {
        let newCorrectOptions = [...editQuestion.correctOptions];
        if (checked) {
            newCorrectOptions.push(option);
        } else {
            newCorrectOptions = newCorrectOptions.filter(opt => opt !== option);
        }
        newCorrectOptions.sort();

        setEditQuestion({ ...editQuestion, correctOptions: newCorrectOptions });

        if (newCorrectOptions.length > 0) {
        setCorrectOptionError('');
    }
    };


    const handleEditClick = async (question) => {
        // Parse options
        const optionsArray = question.options ? question.options.split(',') : ['', '', '', ''];

        // Parse correct option(s)
        let correctOptions = [];
        if (question.correctOption) {
            if (question.questionType === "Multiple Choice") {
                correctOptions = question.correctOption.split(',').filter(opt => opt.trim() !== '');
            } else {
                correctOptions = [question.correctOption];
            }
        }

        // Base edit question state
        const baseEditState = {
            id: question.id,
            quizID: question.quizID,
            languageCode: question.languageCode || 'en-US',
            questionText: question.questionText || '',
            questionNo: question.questionNo || 0,
            imageName: question.imageName || 'No Image',
            questionType: question.questionType || 'Single Choice',
            option1: optionsArray[0] || '',
            option2: optionsArray[1] || '',
            option3: optionsArray[2] || '',
            option4: optionsArray[3] || '',
            correctOptions: correctOptions.length > 0 ? correctOptions : [''],
            imageFile: null
        };

        // Try to fetch image if it exists
        if (question.imageName && question.imageName !== "No Image" && question.imageName !== null) {
            try {
                const response = await axiosInstance.get(`/Question/Image/${question.quizID}/${question.questionNo}/${question.imageName}`, {
                    responseType: 'arraybuffer'
                });

                const blob = new Blob([response.data], { type: 'image/jpeg' });
                const imageFile = new File([blob], question.imageName, { type: 'image/jpeg' });

                baseEditState.imageFile = imageFile;
            } catch (error) {
                // Image fetch failed - continue without image file
                // The imageName is still set, so user can see there was an image
            }
        }

        setEditQuestion(baseEditState);
        setEditQuestionId(question.id);
        setShowEdit(true);
    };


    const handleEdit = () => {        
        let formIsValid = true;
        if (!editQuestion.questionText) {
            setQuestionTextError(lngsltd['Question Text is required']);
            formIsValid = false;
        } else {
            setQuestionTextError('');
        }
        if (!editQuestion.option1) {
            setOption1Error(lngsltd['Option1 is required']);
            formIsValid = false;
        } else {
            setOption1Error('');
        }
        if (!editQuestion.option2) {
            setOption2Error(lngsltd['Option2 is required']);
            formIsValid = false;
        } else {
            setOption2Error('');
        }
        if (!editQuestion.option3 && editQuestion.questionType !== "True/False") {
            setOption3Error(lngsltd['Option3 is required']);
            formIsValid = false;
        } else {
            setOption3Error('');
        }
        if (!editQuestion.option4 && editQuestion.questionType !== "True/False") {
            setOption4Error(lngsltd['Option4 is required']);
            formIsValid = false;
        } else {
            setOption4Error('');
        }

        // Check if question number is empty or zero
        if (!editQuestion.questionNo || parseInt(editQuestion.questionNo) === 0) {
            setQuestionNumberError(lngsltd['Question Number is required and cannot be zero']);
            toast.error("Question Number is required and cannot be zero")
            formIsValid = false;
        } else {
            setQuestionNumberError('');
        }
        // CHANGE 1: Use editQuestion instead of newQuestion
if (
    !editQuestion.correctOptions ||
    editQuestion.correctOptions.length === 0 ||
    (editQuestion.correctOptions.length === 1 && editQuestion.correctOptions[0] === "")
) {
    setCorrectOptionError(lngsltd['Correct Option is required']);
    formIsValid = false;
}
else {
    setCorrectOptionError('');
}
        if (formIsValid) {
            const sortedCorrectOptions = [...editQuestion.correctOptions].sort().join(',');

            const questionData = {
                ...editQuestion,
                correctOptions: sortedCorrectOptions,
            };

            let combinedOptions = '';

            if (editQuestion.questionType !== "True/False") {
                combinedOptions = `${editQuestion.option1},${editQuestion.option2},${editQuestion.option3},${editQuestion.option4}`;
            } else {
                combinedOptions = `${editQuestion.option1},${editQuestion.option2}`;
            }

            const formData = new FormData();
            formData.append('id', editQuestion.id);
            formData.append('languageCode', editQuestion.languageCode);
            formData.append('quizID', editQuestion.quizID);
            formData.append('questionText', editQuestion.questionText);
            formData.append('questionType', editQuestion.questionType);
            formData.append('questionNo', editQuestion.questionNo);
            formData.append('options', combinedOptions);
            if (editQuestion.questionType === "Multiple Choice") {
                formData.append('correctOption', questionData.correctOptions);
            }
            else {
                formData.append('correctOption', editQuestion.correctOption);
            }

            if (editQuestion.imageFile) {
                formData.append('imageFile', editQuestion.imageFile);
                formData.append('imageName', "Image");
            } else if (editQuestion.imageName && editQuestion.imageName !== "No Image") {
                // Preserve existing image if no new image is uploaded
                formData.append('imageName', editQuestion.imageName);
            } else {
                formData.append('imageName', "No Image");
            }

            axiosInstance.put(`/Question/${editQuestionId}`, formData)
                .then((result) => {
                    fetchQuestions();
                    clearEdit();
                    setShowEdit(false);
                    toast.success(lngsltd['Question has been updated']);
                })
                .catch((error) => {
                    toast.error(lngsltd['Failed to update question']);
                    // console.error('Error updating question: ', error);
                });
        }
    };

    const handleDelete = (questionId) => {
        if (window.confirm(lngsltd['Are you sure you want to delete this question?'])) {
            axiosInstance.delete(`/Question/${questionId}`)
                .then((result) => {
                    fetchQuestions();
                    toast.success(lngsltd['Question has been deleted']);
                })
                .catch((error) => {
                    toast.error(lngsltd['Failed to delete question']);
                    // console.error('Error deleting question: ', error);
                });
        }
    };


    const clear = () => {
        setNewQuestion({
            quizID: quizid,
            questionText: '',
            questionType: "Single Choice",
            questionNo: '',
            imageName: '',
            option1: '',
            option2: '',
            option3: '',
            option4: '',
            correctOptions: '',
            imageFile: ''
        });
    };


    const clearEdit = () => {
        setEditQuestion({
            quizID: quizid,
            questionText: '',
            questionType: "Single Choice",
            questionNo: '',
            imageName: '',
            option1: '',
            option2: '',
            option3: '',
            option4: '',
            correctOptions: '',
            imageFile: ''
        });
    };

    const clearErrors = () => {
        setQuestionTextError('');
        setOption1Error('');
        setOption2Error('');
        setOption3Error('');
        setOption4Error('');
        setCorrectOptionError('');
        setEditQuestionTextError('');
        setEditOption1Error('');
        setEditOption2Error('');
        setEditOption3Error('');
        setEditOption4Error('');
        setEditCorrectOptionError('');

    };

    const handleRemoveImage = () => {
        setNewQuestion(prevState => ({
            ...prevState,
            imageFile: null,
            imageName: "No Image"
        }));
        setEditQuestion(prevState => ({
            ...prevState,
            imageFile: null,
            imageName: "No Image"
        }));
    };

    return (
        <Box className='fullHW' px={6} py={4} display="flex" flexDirection="column">
            <Typography variant="h5" fontWeight={600}>{lngsltd["List of Questions"]}</Typography>
            <ContentBlock sx={{ flexGrow: 1, display: "flex", flexDirection: "column", py: 4, "& p": { m: 0 } }}>
                <ToastContainer
                    autoClose={2000}
                    progressClassName='custom-toast-progress-bar' />
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <Button size="large" variant="contained" onClick={() => setShowAdd(true)} startIcon={<AddIcon />} sx={{ textTransform: "initial" }}>
                        {lngsltd["Add Question"]}
                    </Button>
                </Box>
                <Box mt={2} flexGrow={1} overflow="hidden" width="90%">
                    <QuizQuestionsTable
                        lngsltd={lngsltd}
                        data={questions}
                        quizid={quizid}
                        handleEditClick={handleEditClick}
                        handleDelete={handleDelete}
                    />
                </Box>
                <CreateQuizQuestionModal
                    showAdd={showAdd}
                    setShowAdd={setShowAdd}
                    lngsltd={lngsltd}
                    newQuestion={newQuestion}
                    handleInputChangeQN={handleInputChangeQN}
                    questionNumberError={questionNumberError}
                    handleInputChange={handleInputChange}
                    questionTextError={questionTextError}
                    handleRemoveImage={handleRemoveImage}
                    setNewQuestion={setNewQuestion}
                    option1Error={option1Error}
                    option2Error={option2Error}
                    option3Error={option3Error}
                    option4Error={option4Error}
                    correctOptionError={correctOptionError}
                    handleCheckboxChange={handleCheckboxChange}
                    handleAdd={handleAdd}
                />
                <UpdateQuizQuestionModal
                    showEdit={showEdit}
                    setShowEdit={setShowEdit}
                    lngsltd={lngsltd}
                    editQuestion={editQuestion}
                    handleEditInputChangeQN={handleEditInputChangeQN}
                    questionNumberError={questionNumberError}
                    handleEditInputChange={handleEditInputChange}
                    questionTextError={questionTextError}
                    handleRemoveImage={handleRemoveImage}
                    setEditQuestion={setEditQuestion}
                    option1Error={option1Error}
                    option2Error={option2Error}
                    option3Error={option3Error}
                    option4Error={option4Error}
                    correctOptionError={correctOptionError}
                    handleEditCheckboxChange={handleEditCheckboxChange}
                    handleEdit={handleEdit}
                />
            </ContentBlock>
        </Box>
    );
};

export default Questions;




